import { COLORS, colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1.5,
      p: 2,
    },
    avatar: {
      width: 44,
      height: 44,
      flexShrink: 0,
    },
    userData: {
      minWidth: 0,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    name: {
      color: colors.white,
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '20px',
    },
    emailRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      mt: 0.3,
    },
    emailIcon: {
      width: 13,
      height: 13,
      color: COLORS.PROFILE_GREY,
    },
    email: {
      color: COLORS.PROFILE_GREY,
      fontSize: 12,
      lineHeight: '16px',
    },
    followBtn: {
      mt: 0.75,
      px: 0,
      py: 0.5,
      minWidth: 0,
      width: 'fit-content',
      gap: 0.75,
      backgroundColor: 'transparent',
      color: colors.white,
      textTransform: 'none',
      fontSize: 13,
      fontWeight: 600,
      '&:hover': {
        backgroundColor: 'transparent',
        opacity: 0.85,
      },
    },
    followIcon: {
      width: 14,
      height: 14,
      color: 'inherit',
    },
  };
};
